import {SupportedLocales} from '#types/locale.js';

export const externalMediaLibrariesLanguage = {
  [SupportedLocales.EN]: {
    description:
      'Manage your external media libraries for our Template Editor in Content Studio.',
  },
  [SupportedLocales.ES]: {
    description:
      'Administre sus bibliotecas multimedia externas para nuestro Editor de Plantillas en Content Studio.',
  },
};
